export default __webpack_public_path__ + "static/media/grey-plane.4d316330.svg";